// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"mp-z","badgeLink":"np-z","category":"op-z"};